export default __webpack_public_path__ + "static/media/Maindashboardbg.93d68fe9.png";